var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._g({ref:"image",staticClass:"picture",class:{ 'pinch-zoom-transition': _vm.enableTransition },attrs:{"src":_vm.src,"lazy":""}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }